// extracted by mini-css-extract-plugin
export var lg = "_4c-4";
export var md = "_4c-3";
export var sm = "_4c-2";
export var xs = "_4c-1";
export var xxs = "_4c-0";